// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ObjectNoResponse,
    ProviderPayerProvider,
    ProviderPayerProviderSortType,
    SupportCreatePayerProviderPayload,
    SupportPayerProvider,
    SupportPayerProviderSortType,
    SupportReplacePayerProviderPayload,
    SupportUpdatePayerProviderPayload,
    SupportCreatePayerProviderPayloadToJSON,
    SupportReplacePayerProviderPayloadToJSON,
    SupportUpdatePayerProviderPayloadToJSON,
    ObjectNoResponseFromJSON,
    ProviderPayerProviderFromJSON,
    SupportPayerProviderFromJSON,
} from '../models';

export interface CreateSupportPayerProviderRequest {
    supportCreatePayerProviderPayload: SupportCreatePayerProviderPayload;
}

export interface DisableSupportPayerProviderRequest {
    id: string;
}

export interface GetProviderPayerProviderRequest {
    id: string;
}

export interface GetSupportPayerProviderRequest {
    id: string;
}

export interface ListProviderPayerProvidersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListProviderPayerProvidersOrderEnum>;
    filterHalt?: string;
    filterCreated?: Array<string>;
    filterPayerId?: Array<string>;
    filterProviderId?: Array<string>;
    sort?: Array<ProviderPayerProviderSortType>;
}

export interface ListSupportPayerProvidersRequest {
    filterId?: Array<string>;
    limit?: number;
    offset?: number;
    order?: Array<ListSupportPayerProvidersOrderEnum>;
    filterHalt?: string;
    filterStarred?: string;
    filterCreated?: Array<string>;
    filterActive?: string;
    filterPayerId?: Array<string>;
    filterProviderId?: Array<string>;
    sort?: Array<SupportPayerProviderSortType>;
}

export interface ReplaceSupportPayerProviderRequest {
    supportReplacePayerProviderPayload: SupportReplacePayerProviderPayload;
}

export interface UpdateSupportPayerProviderRequest {
    id: string;
    supportUpdatePayerProviderPayload: SupportUpdatePayerProviderPayload;
}

/**
 * no description
 */
export class PayerProviderApi extends runtime.BaseAPI {

    /**
     * Create a payer provider
     * Create a payer provider
     */
    async createSupportPayerProviderRaw(requestParameters: CreateSupportPayerProviderRequest): Promise<runtime.ApiResponse<SupportPayerProvider>> {
        if (requestParameters['supportCreatePayerProviderPayload'] === null || requestParameters['supportCreatePayerProviderPayload'] === undefined) {
            throw new runtime.RequiredError('supportCreatePayerProviderPayload','Required parameter requestParameters.supportCreatePayerProviderPayload was null or undefined when calling createSupportPayerProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["create:payerprovider", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payerprovider`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupportCreatePayerProviderPayloadToJSON(requestParameters['supportCreatePayerProviderPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportPayerProviderFromJSON(jsonValue));
    }

    /**
     * Create a payer provider
     * Create a payer provider
     */
    async createSupportPayerProvider(requestParameters: CreateSupportPayerProviderRequest): Promise<SupportPayerProvider> {
        const response = await this.createSupportPayerProviderRaw(requestParameters);
        return await response.value();
    }

    /**
     * Disable a payer provider
     * Disable a payer provider
     */
    async disableSupportPayerProviderRaw(requestParameters: DisableSupportPayerProviderRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling disableSupportPayerProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["delete:payerprovider", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payerprovider/{id}/disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Disable a payer provider
     * Disable a payer provider
     */
    async disableSupportPayerProvider(requestParameters: DisableSupportPayerProviderRequest): Promise<ObjectNoResponse> {
        const response = await this.disableSupportPayerProviderRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a payer provider
     * Get a payer provider
     */
    async getProviderPayerProviderRaw(requestParameters: GetProviderPayerProviderRequest): Promise<runtime.ApiResponse<ProviderPayerProvider>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getProviderPayerProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payerprovider"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/payerprovider/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ProviderPayerProviderFromJSON(jsonValue));
    }

    /**
     * Gets a payer provider
     * Get a payer provider
     */
    async getProviderPayerProvider(requestParameters: GetProviderPayerProviderRequest): Promise<ProviderPayerProvider> {
        const response = await this.getProviderPayerProviderRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a payer provider
     * Get a payer provider
     */
    async getSupportPayerProviderRaw(requestParameters: GetSupportPayerProviderRequest): Promise<runtime.ApiResponse<SupportPayerProvider>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling getSupportPayerProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payerprovider", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payerprovider/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => SupportPayerProviderFromJSON(jsonValue));
    }

    /**
     * Gets a payer provider
     * Get a payer provider
     */
    async getSupportPayerProvider(requestParameters: GetSupportPayerProviderRequest): Promise<SupportPayerProvider> {
        const response = await this.getSupportPayerProviderRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of payer providers
     * Get a list of payer providers
     */
    async listProviderPayerProvidersRaw(requestParameters: ListProviderPayerProvidersRequest): Promise<runtime.ApiResponse<Array<ProviderPayerProvider>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterHalt !== undefined) {
            queryParameters['filterHalt'] = requestParameters.filterHalt;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payerprovider"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/provider/payerprovider`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProviderPayerProviderFromJSON));
    }

    /**
     * Gets a list of payer providers
     * Get a list of payer providers
     */
    async listProviderPayerProviders(requestParameters: ListProviderPayerProvidersRequest): Promise<Array<ProviderPayerProvider>> {
        const response = await this.listProviderPayerProvidersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Gets a list of payer providers
     * Get a list of payer providers
     */
    async listSupportPayerProvidersRaw(requestParameters: ListSupportPayerProvidersRequest): Promise<runtime.ApiResponse<Array<SupportPayerProvider>>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.filterId) {
            queryParameters['filterId'] = requestParameters.filterId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.order) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.filterHalt !== undefined) {
            queryParameters['filterHalt'] = requestParameters.filterHalt;
        }

        if (requestParameters.filterStarred !== undefined) {
            queryParameters['filterStarred'] = requestParameters.filterStarred;
        }

        if (requestParameters.filterCreated) {
            queryParameters['filterCreated'] = requestParameters.filterCreated;
        }

        if (requestParameters.filterActive !== undefined) {
            queryParameters['filterActive'] = requestParameters.filterActive;
        }

        if (requestParameters.filterPayerId) {
            queryParameters['filterPayerId'] = requestParameters.filterPayerId;
        }

        if (requestParameters.filterProviderId) {
            queryParameters['filterProviderId'] = requestParameters.filterProviderId;
        }

        if (requestParameters.sort) {
            queryParameters['sort'] = requestParameters.sort;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["read:payerprovider", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payerprovider`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SupportPayerProviderFromJSON));
    }

    /**
     * Gets a list of payer providers
     * Get a list of payer providers
     */
    async listSupportPayerProviders(requestParameters: ListSupportPayerProvidersRequest): Promise<Array<SupportPayerProvider>> {
        const response = await this.listSupportPayerProvidersRaw(requestParameters);
        return await response.value();
    }

    /**
     * Replace a payer provider
     * Replace a payer provider
     */
    async replaceSupportPayerProviderRaw(requestParameters: ReplaceSupportPayerProviderRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['supportReplacePayerProviderPayload'] === null || requestParameters['supportReplacePayerProviderPayload'] === undefined) {
            throw new runtime.RequiredError('supportReplacePayerProviderPayload','Required parameter requestParameters.supportReplacePayerProviderPayload was null or undefined when calling replaceSupportPayerProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payerprovider", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payerprovider/replace`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportReplacePayerProviderPayloadToJSON(requestParameters['supportReplacePayerProviderPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Replace a payer provider
     * Replace a payer provider
     */
    async replaceSupportPayerProvider(requestParameters: ReplaceSupportPayerProviderRequest): Promise<ObjectNoResponse> {
        const response = await this.replaceSupportPayerProviderRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update a payer provider
     * Update a payer provider
     */
    async updateSupportPayerProviderRaw(requestParameters: UpdateSupportPayerProviderRequest): Promise<runtime.ApiResponse<ObjectNoResponse>> {
        if (requestParameters['id'] === null || requestParameters['id'] === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateSupportPayerProvider.');
        }

        if (requestParameters['supportUpdatePayerProviderPayload'] === null || requestParameters['supportUpdatePayerProviderPayload'] === undefined) {
            throw new runtime.RequiredError('supportUpdatePayerProviderPayload','Required parameter requestParameters.supportUpdatePayerProviderPayload was null or undefined when calling updateSupportPayerProvider.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            if (typeof this.configuration.accessToken === 'function') {
                headerParameters["Authorization"] = this.configuration.accessToken("standard_auth", ["update:payerprovider", "support"]);
            } else {
                headerParameters["Authorization"] = this.configuration.accessToken;
            }
        }

        const response = await this.request({
            path: `/support/payerprovider/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SupportUpdatePayerProviderPayloadToJSON(requestParameters['supportUpdatePayerProviderPayload']),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ObjectNoResponseFromJSON(jsonValue));
    }

    /**
     * Update a payer provider
     * Update a payer provider
     */
    async updateSupportPayerProvider(requestParameters: UpdateSupportPayerProviderRequest): Promise<ObjectNoResponse> {
        const response = await this.updateSupportPayerProviderRaw(requestParameters);
        return await response.value();
    }

}

/**
    * @export
    * @enum {string}
    */
export enum ListProviderPayerProvidersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
/**
    * @export
    * @enum {string}
    */
export enum ListSupportPayerProvidersOrderEnum {
    ASCENDING = 'ASCENDING',
    DESCENDING = 'DESCENDING'
}
